import { Events } from '@ezchops/helpers';
export class SoundNode extends Events.EventEmitter {
    audioContext;
    buffer;
    gain;
    offset;
    gainNode;
    sourceNode;
    _status;
    constructor(audioContext, buffer, gain, offset) {
        super();
        this.audioContext = audioContext;
        this.buffer = buffer;
        this.gain = gain;
        this.offset = offset;
        this.gain = gain;
        this.gainNode = new GainNode(audioContext, { gain });
        this.sourceNode = new AudioBufferSourceNode(audioContext, { buffer });
        this.sourceNode.connect(this.gainNode);
        this.gainNode.connect(audioContext.destination);
        this._status = 'created';
    }
    get status() {
        return this._status;
    }
    play = (when) => {
        if (when == null || when >= 0) {
            this.sourceNode.start(when, this.offset);
            this._status = 'scheduled';
            this.sourceNode.addEventListener('ended', () => {
                this._status = 'ended';
                this.emit('ended', undefined);
                this.close();
            });
        }
    };
    close() {
        if (this.status != 'disconnected') {
            this.gainNode.disconnect();
            this.sourceNode.disconnect();
            this._status = 'disconnected';
        }
    }
}
//# sourceMappingURL=SoundNode.js.map